import { supabase, ServiceResponse, handleServiceCall } from './supabase';

export interface Brick {
    type: 'text' | 'date' | 'separator' | 'sequence' | 'random' | 'staff' | 'company';
    value?: string;
    format?: string;
    length?: number;
}

export interface NumberGenerationRule {
    id?: string;
    company_id: string;
    user_id?: string | null;
    type: 'tracking_no' | 'batch_no';
    prefix: string;
    date_format: string;
    sequence_length: number;
    current_value: number;
    last_generated_date: string;
    generation_strategy: 'SEQUENCE' | 'RANDOM_ALPHA' | 'MANUAL_ASK';
    bricks?: Brick[];
}

export const NumberRuleService = {
    async getRules(companyId: string): Promise<ServiceResponse<NumberGenerationRule[]>> {
        return handleServiceCall(
            supabase.from('number_generation_rules')
                .select('*')
                .eq('company_id', companyId)
        );
    },

    async saveRule(rule: Partial<NumberGenerationRule>): Promise<ServiceResponse<NumberGenerationRule>> {
        if (rule.id) {
            return handleServiceCall(
                supabase.from('number_generation_rules')
                    .update(rule)
                    .eq('id', rule.id)
                    .select()
                    .single()
            );
        } else {
            return handleServiceCall(
                supabase.from('number_generation_rules')
                    .insert(rule)
                    .select()
                    .single()
            );
        }
    }
};
